import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { nowBatchEventsConfig } from '@v2/pages/machines/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const BatchEventsStack = createStackNavigator();

const BatchEventsNavigator = () => {
  return (
    <BatchEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {nowBatchEventsConfig.map(({ Component, name }) => (
        <BatchEventsStack.Screen key={name} name={name} component={Component} />
      ))}
    </BatchEventsStack.Navigator>
  );
};

export { BatchEventsNavigator };
